<template>
  <v-container fluid class="px-1 py-1">
    <CommonTable
        :title="title"
        :embedded="embedded"
        :height="height"
        :dto-list-query="dtoListQuery"
        :dto-detail-query="dtoDetailQuery"
        :dto-action-command="dtoActionCommand"
        :store-name="storeName"
        :detail-store-name="detailStoreName"
        detailComponentPass="/CoreComponent/BatchRunComponent/BatchRunComponentDetail"
        :parent-component="$options.name"
        @alternate_action="onAlternateAction($event)"
        :qrcode="qrcode"
    >
      <template v-slot:bar>
        <slot name="bar"></slot>
      </template>
      <template v-slot:top>
        <slot name="top"></slot>
      </template>
      <template v-slot:top.bar.filter>
        <slot name="top.bar.filter"></slot>
      </template>
      <template v-slot:item.component__article_display="{ item }">
        <v-chip
            outlined
            v-if="!!item.component_uid && !!storeAggregate.rootData[item.component_uid] && !!storeAggregate.rootData[item.component_uid].article_display"
            @click="detailStoreComponent.openDetailDialog({item: null, uid: item.component_uid})"
        >
          {{ storeAggregate.rootData[item.component_uid].article_display }}
        </v-chip>
      </template>
      <template v-slot:item.component__alias="{ item }">
        <v-chip
            outlined
            v-if="!!item.component_uid && !!storeAggregate.rootData[item.component_uid]"
            @click="detailStoreComponent.openDetailDialog({item: null, uid: item.component_uid})"
        >
          {{ storeAggregate.rootData[item.component_uid].alias }}
        </v-chip>
      </template>
      <template v-slot:item.material_reservations_uid="{ item }">
        <span v-for="material_reservation_uid of item.material_reservations_uid">
          <ChoiceSupplyType
              v-if="storeAggregate.rootData[material_reservation_uid].deleted === false"
              :item="storeAggregate.rootData[storeAggregate.rootData[material_reservation_uid].material_uid]"
              :small="true"
              :readonly="true"
              @click="detailStoreMaterial.openDetailDialog({item: null, uid: storeAggregate.rootData[material_reservation_uid].material_uid})"
          >
            <template v-slot:view="{item}">
              <v-icon
                  v-if=" storeAggregate.rootData[storeAggregate.rootData[material_reservation_uid].material_uid].deleted === true"
                  small
                  color="red darken-4"
              >mdi-delete-outline</v-icon>
              {{ item.supply_type }} : {{ storeAggregate.rootData[material_reservation_uid].quantity }} (..{{ storeAggregate.rootData[storeAggregate.rootData[material_reservation_uid].material_uid].last4uid }})
            </template>
          </ChoiceSupplyType>
        </span>
        {{ '' }}
      </template>
      <template v-slot:footer.prepend>
        <slot name="footer.prepend"></slot>
      </template>
    </CommonTable>
    <v-dialog
        v-if="!!detailStoreComponent"
        v-model="detailStoreComponent.dialogDetail"
        persistent
        scrollable
    >
      <ComponentDetail
          :uid-item="detailStoreComponent.uidItem"
          :store-name="detailStoreComponentName"
          :modalDialog="true"
          :route-full-screen="{name: 'ComponentDetail', params: {itemUid: detailStoreComponent.uidItem}}"
          :main-validator="true"
          :embedded="embedded"
      ></ComponentDetail>
    </v-dialog>
    <v-dialog
        v-if="!!detailStoreMaterial"
        v-model="detailStoreMaterial.dialogDetail"
        persistent
        scrollable
    >
      <MaterialDetail
          :uid-item="detailStoreMaterial.uidItem"
          :store-name="detailStoreMaterialName"
          :modalDialog="true"
          :route-full-screen="{name: 'MaterialDetail', params: {itemUid: detailStoreMaterial.uidItem}}"
          :main-validator="true"
          :embedded="embedded"
      ></MaterialDetail>
    </v-dialog>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useTableStore} from "@/components/Common/CommonTable";
import CommonTable from "@/components/Common/CommonTable";
import {v4 as uuidv4} from "uuid";
import ChoiceSupplyType from "@/components/CoreComponent/ProductOrder/ChoiceSupplyType";
import {useDetailStore} from "@/components/Common/CommonDetail";
import ComponentDetail from "@/components/CoreComponent/Component/ComponentDetail";
import MaterialDetail from "@/components/CoreMaterial/Material/MaterialDetail";

export default {
  name: "BatchRunComponentTable",

  props: {
    embedded: {default: false},
    qrcode: {default: null},
    title: {default: 'BatchRunComponent'},
    headers: {default: null},
    height: {default: null},
    storeName: {
      type: [String], default() {
        return uuidv4()
      }
    },
    dtoDetailQuery: {default: 'BatchRunComponentDetailQueryDTO'},
    detailStoreName: {
      type: [String], default() {
        return uuidv4()
      }
    },
    dtoListQuery: {type: [String], default: 'BatchRunComponentListQueryDTO'},
    dtoActionCommand: {type: [String], default: 'BatchRunComponentActionCommandDTO'},
    mainValidator: {type: [Boolean], default: false},
    selectedBatchRunUid: {default: null},
  },

  components: {
    CommonTable,
    ChoiceSupplyType,
    ComponentDetail,
    MaterialDetail,
    BatchRunComponentDetail: () => import("@/components/CoreComponent/BatchRunComponent/BatchRunComponentDetail"),
  },

  watch: {
    selectedBatchRunUid: {
      handler(newValue, oldValue) {
        // console.log('watch selectedBatchRunUid', newValue, oldValue)
        this.filterBatchRun()
        this.storeTable.selected = []
      },
      deep: true
    },
  },

  methods: {
    onAlternateAction(event) {
      console.log('onAlternateAction', event)
      if (event.actionName === 'alternate_update_from_bomsheet')
        this.storeTable.onAction({
          actionName: 'update_from_bomsheet',
          actionUid: event.actionUid,
          data: {batch_run_uid: this.selectedBatchRunUid}
        })
    }
    ,
    filterBatchRun() {
      this.storeTable.query_filters = {
        and_concat: true,
        filter_list: [
          {param_compare: 'batch_run__uid', value: this.selectedBatchRunUid},
        ],
        enable: true,
      }
    },
  },


  mounted() {
    this.storeTable = useTableStore(this.storeName)()
    this.storeTable.headers = this.headers || [
      // {text: 'uid', value: 'uid', sortable: true, filterable: true, divider: true, width: 300},
      {text: 'Task', value: 'task_dto', sortable: false, filterable: true, divider: true, width: 25},
      {text: 'Article', value: 'component__article_display', sortable: true, filterable: true, divider: true},
      {text: 'Customer article', value: 'customer_article', sortable: true, filterable: true, divider: true},
      {text: 'Component', value: 'component__alias', sortable: true, filterable: true, divider: true},
      {text: 'Line QTY', value: 'line_count', sortable: false, filterable: true, divider: true, width: 70,},
      {text: 'Quantity', value: 'quantity', sortable: true, filterable: true, divider: true, width: 70,},
      {text: 'Need quantity', value: 'need_quantity', sortable: true, filterable: true, divider: true, width: 70,},
      {
        text: 'Material reservation quantity',
        value: 'reservation_quantity',
        sortable: true,
        filterable: true,
        divider: true,
        width: 70,
      },
      {text: 'Sum qty delta', value: 'sum_qty_delta', sortable: true, filterable: true, divider: true, width: 70,},
      {
        text: 'Materials',
        value: 'material_reservations_uid',
        sortable: true,
        filterable: true,
        divider: false,
        width: 500
      },
      {text: '', value: 'edit', sortable: false, filterable: true, divider: true, width: 10},
      {text: 'edited_by', value: 'edited_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'edited_on', value: 'edited_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: 'created_by', value: 'created_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'created_on', value: 'created_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: '', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 30},
    ]
    this.storeAggregate = useAggregateStore()
    if (!!this.storeTable) {
      this.storeTable.dtoDetailQuery = this.dtoDetailQuery
      this.storeTable.dtoListQuery = this.dtoListQuery
      this.storeTable.dtoActionCommand = this.dtoActionCommand
      this.storeTable.options.sortBy = ['component__article_display', 'component__alias']
      this.storeTable.options.itemsPerPage = -1
      this.storeTable.options.sortDesc = [true, true]
      this.storeTable.options.multiSort = false
    }
    this.filterBatchRun()
    this.detailStoreComponent = useDetailStore(this.detailStoreComponentName)()
    this.detailStoreMaterial = useDetailStore(this.detailStoreMaterialName)()
  },

  data() {
    return {
      storeTable: null,
      detailStoreComponent: null,
      detailStoreComponentName: uuidv4(),

      detailStoreMaterial: null,
      detailStoreMaterialName: uuidv4(),
    }
  },
}
</script>

<style scoped>

</style>